import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Wrench } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/tools')({
    staticData: {
        breadcrumb: {
            title: 'Tools',
            inactive: true,
        },
        roles: ['user', 'shared_edit_user', 'org_admin'],
        modules: ['auto-detect', 'compliance-audit', 'document-analyzer', 'website-checker', 'pds-compare'],
        ui: {
            icon: Wrench,
        },
    },
    component: Outlet,
});
